import { HttpParams } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { LazyLoadEvent } from 'primeng/primeng';

import { BaseCrudService } from '../../shared/_utils/services/base-crud-service';
import { QueryOperator } from '../../shared/_utils/services/query-operator.enum';
import { Absence } from '../entities/absence';
import { Observable } from 'rxjs/Observable';
import { ResponsePageable } from '../../shared/_utils/services/responsePageable';
import { tap } from 'rxjs/operators';

@Injectable()
export class AbsenceService extends BaseCrudService<Absence> {

    public uri = '/api/absence/';

    constructor(injector: Injector) {
        super(injector);
        //console.log('Instance AbsenceService');
    }

    buildSentence(entity?: Absence, event?: LazyLoadEvent): HttpParams {
        if (entity) {
            let query = entity.code ? 'code'
                + QueryOperator.Contain + entity.code
                + QueryOperator.Split : QueryOperator.Empty;
            query = query.concat(
                entity.name ? 'name'
                    + QueryOperator.Contain + entity.name
                    + QueryOperator.Split : QueryOperator.Empty
            );
            query = query.concat(
                entity.abbreviation ? 'abbreviation'
                    + QueryOperator.Contain + entity.abbreviation
                    + QueryOperator.Split : QueryOperator.Empty
            );
            query = query.concat(
                entity.status ? 'status'
                    + QueryOperator.Equal + entity.status
                    + QueryOperator.Split : QueryOperator.Empty
            );

            if (entity.absenceImpact) {
                query = query.concat(
                    entity.absenceImpact.id ? 'absenceImpact.id'
                        + QueryOperator.Equal + entity.absenceType.id
                        + QueryOperator.Split : QueryOperator.Empty
                );
            };

            if (entity.absenceType) {
                query = query.concat(
                    entity.absenceType.id ? 'absenceType.id'
                        + QueryOperator.Equal + entity.absenceType.id
                        + QueryOperator.Split : QueryOperator.Empty
                );
            };
            query = query.concat(
                entity.hasAttachment ? 'hasAttachment'
                    + QueryOperator.Equal + entity.hasAttachment
                    + QueryOperator.Split : QueryOperator.Empty
            );
            query = query.concat(
                entity.isJustification ? 'isJustification'
                    + QueryOperator.Equal + entity.isJustification
                    + QueryOperator.Split : QueryOperator.Empty
            );
            query = query.concat(
                entity.isJustifyHours ? 'isJustifyHours'
                    + QueryOperator.Equal + entity.isJustifyHours
                    + QueryOperator.Split : QueryOperator.Empty
            );
            query = query.concat(
                entity.isPaid ? 'isPaid'
                    + QueryOperator.Equal + entity.isPaid
                    + QueryOperator.Split : QueryOperator.Empty
            );
            query = query.concat(
                entity.isPublished ? 'isPublished'
                    + QueryOperator.Equal + entity.isPublished
                    + QueryOperator.Split : QueryOperator.Empty
            );
            query = query.concat(
                entity.isReplaceShift ? 'isReplaceShift'
                    + QueryOperator.Equal + entity.isReplaceShift
                    + QueryOperator.Split : QueryOperator.Empty
            );
            query = query.concat(
                entity.isUnpaid ? 'isUnpaid'
                    + QueryOperator.Equal + entity.isUnpaid
                    + QueryOperator.Split : QueryOperator.Empty
            );
            query = query.concat(
                entity.isVacation ? 'isVacation'
                    + QueryOperator.Equal + entity.isVacation
                    + QueryOperator.Split : QueryOperator.Empty
            );

            if (entity.periodAccum) {
                query = query.concat(
                    entity.periodAccum.id ? 'periodAccum.id'
                        + QueryOperator.Equal + entity.periodAccum.id
                        + QueryOperator.Split : QueryOperator.Empty
                );
            };

            if (entity.period) {
                query = query.concat(
                    entity.period.id ? 'period.id'
                        + QueryOperator.Equal + entity.period.id
                        + QueryOperator.Split : QueryOperator.Empty
                );
            };

            query = query.concat(
                entity.periodLimit ? 'periodLimit'
                    + QueryOperator.Equal + entity.periodLimit
                    + QueryOperator.Split : QueryOperator.Empty
            );

            if (entity.plameAbsence) {
                query = query.concat(
                    entity.plameAbsence.id ? 'plameAbsence.id'
                        + QueryOperator.Equal + entity.plameAbsence.id
                        + QueryOperator.Split : QueryOperator.Empty
                );
            };

            if (entity.executingUnit && entity.executingUnit.id) {
                query = query.concat(
                    entity.executingUnit.id ? 'executingUnit.id'
                        + QueryOperator.Equal + entity.executingUnit.id
                        + QueryOperator.Split : QueryOperator.Empty
                );
            }

            this.httpParams = this.httpParams.set(QueryOperator.QueryParam, query);
        }

        if (event) {
            const page = ((event.first + event.rows) / event.rows - 1).toString();
            const size = event.rows.toString();
            this.httpParams = this.httpParams.set(QueryOperator.PageParam, page);
            this.httpParams = this.httpParams.set(QueryOperator.SizeParam, size);
        }
        return this.httpParams;
    }

    searchTotal(entity?: Absence): Observable<ResponsePageable<Absence>> {

        const url = this.rutaServidor + this.uri;
        this.spinnerService.showAll();
        return this.httpClient.get<ResponsePageable<Absence>>(url, { params: this.buildSentence(entity, undefined) })
            .pipe(
                tap(response => {
                    if (response.numberOfElements > 0) {
                        response.content.forEach((value) => {
                            // debugger;
                            this.addLogicToSearch(value);
                            this.convertToDate(value);
                        })
                    }
                    //console.log(response);
                    this.spinnerService.hideAll();
                    return response;
                })
            );
    }
}



// WEBPACK FOOTER //
// ./src/app/core/services/absence.service.ts